import type { FC } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';

import styles from './MessageInput.module.css';

interface SupportingTextProps {
  isBetRequiredToChat: boolean;
  cashierCallback?: () => void;
}

export const SupportingText: FC<SupportingTextProps> = ({ isBetRequiredToChat, cashierCallback }) => {
  const translationKey = isBetRequiredToChat ? 'CHAT_ACTIVATED' : 'BALANCETOCHAT';
  return (
    <span className={styles.messageInput__supportingText}>
      <L10nText tk={translationKey} />
      {!isBetRequiredToChat && cashierCallback ? (
        <div className={styles.messageInput__buttonLink} onMouseDown={cashierCallback}>
          <L10nText tk="GO_TO_CASHIER" />
        </div>
      ) : null}
    </span>
  );
};
